
import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _editSenderUserInitQuery = (organisation_id: string, organisation_user_id: string) => ({
  organisations_by_pk: params(
    { id: rawString(organisation_id) },
    {
      name: types.string,
    }
  ),
  users_sender_by_pk: params(
    { id: rawString(organisation_user_id) },
    {
      id: types.string,
      first_name: types.string,
      last_name: types.string,
      full_name: types.string,
      email: types.string,
      gmc_number: types.string,
      dob: types.string,
      gender: types.string,
      sender_type: types.string,
      organisations: [{
        id: types.string,
        organisation: {
          id: types.string,
          name: types.string,
        },
      }],
      enum_sender_type: {
        sender_type: types.string,
        description: types.string,
      },
    },
  ),
  organisations: params(
    { order_by: { name: 'asc' }},
    [{
      id: types.string,
      name: types.string,
    }],
  ),
  enum_sender_types: [{
  	sender_type: types.string,
    description: types.string,
  }],
});

type X = Unpacked<typeof _editSenderUserInitQuery>
export type SenderUser = X['users_sender_by_pk'];
export type OrganisationAssignment = SenderUser['organisations'][0];
export type Organisation = X['organisations'][0];
export type EnumSenderType = X['enum_sender_types'][0];

export const editSenderUserInitQuery = (organisation_id: string, organisation_user_id: string) => gql`${query(_editSenderUserInitQuery(organisation_id, organisation_user_id))}`;
